import React, {Component} from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";


export class UserMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null
        }

        this.signOut = this.signOut.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    handleClick = event => {
        this.setState({anchorEl: event.currentTarget});
    };

    handleClose = () => {
        this.setState({anchorEl: null});
    }

    changePassword() {
        this.handleClose();
        this.props.history.push('/app/changePassword/');
    }

    signOut() {
        localStorage.clear();

        this.props.history.push('/login/');
    }

    render() {
        return (
            <React.Fragment>
                <button className="p-link layout-menu-button" onClick={this.handleClick}>
                    <span className="layout-topbar-icon pi pi-user"/>
                </button>
                <Menu
                    id="long-menu"
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleClose}
                    PaperProps={{
                        style: {
                            maxHeight: 48 * 4.5,
                            width: 200,
                        },
                    }}
                >
                    <MenuItem onClick={this.changePassword}>Cambiar Password</MenuItem>
                    <MenuItem onClick={this.signOut}>Log Out</MenuItem>
                </Menu>
            </React.Fragment>
        );
    }
}

export default UserMenu;